import { z } from 'zod';

export const faqSchema = z.object({
  question_uz: z.string().trim().min(1, 'faqs.form.errors.required').max(500, 'faqs.form.errors.tooLong'),
  question_ru: z.string().trim().max(500, 'faqs.form.errors.tooLong'),
  question_en: z.string().trim().max(500, 'faqs.form.errors.tooLong'),
  question_kk: z.string().trim().max(500, 'faqs.form.errors.tooLong'),
  answer_uz: z.string().trim().min(1, 'faqs.form.errors.required').max(5000, 'faqs.form.errors.tooLong'),
  answer_ru: z.string().trim().max(5000, 'faqs.form.errors.tooLong'),
  answer_en: z.string().trim().max(5000, 'faqs.form.errors.tooLong'),
  answer_kk: z.string().trim().max(5000, 'faqs.form.errors.tooLong'),
  order: z.coerce.number().int().min(0, 'faqs.form.errors.order').max(100000, 'faqs.form.errors.order'),
  is_active: z.boolean(),
});

export type FaqFormValues = z.infer<typeof faqSchema>;
